import { Serializable } from '@core/models';

export class SectionFilters extends Serializable {
  static levels = {
    0: '',
    1: '\xa0‣ ',
    2: '\xa0\xa0\xa0\xa0• '
  }

  constructor(parentGuid, sectionGuid, sectionTitle, childrenGuids, productGuids, menuProductGuids) {
    super();
    this.parentGuid = parentGuid || '';
    this.sectionGuid = sectionGuid || '';
    this.sectionTitle = sectionTitle || '';
    this.childrenGuids = childrenGuids || [];
    this.productGuids = productGuids || [];
    this.allProductGuids = [];
    this.menuProductGuids = menuProductGuids || [];
  }

  static toInstance(props = {}) {
    return new SectionFilters(props.parent_guid, props.section_guid, props.section_title,
      props.children_guids, props.product_guids, props.menu_product_guids);
  }

  isDisabled(getMultipleSections) {
    return getMultipleSections ? this.allProductGuids.length === 0 : this.menuProductGuids.length === 0;
  }

  #depthLevel(childToParent) {
    let level = 0;
    let currentChild = this.sectionGuid;
    while (childToParent.get(currentChild)) {
      currentChild = childToParent.get(currentChild);
      level += 1;
    }
    return level;
  }

  #filterName(childToParent) {
    const level = this.#depthLevel(childToParent);
    const prefix = SectionFilters.levels[level] || '';
    return `${prefix}${this.sectionTitle}`;
  }

  getRepresentation(childToParent, getMultipleSections) {
    return {
      sectionGuid: this.sectionGuid,
      sectionTitle: this.#filterName(childToParent),
      disabled: this.isDisabled(getMultipleSections)
    };
  }

  serialize() {
    return {
      parent_guid: this.parentGuid,
      section_guid: this.sectionGuid,
      section_title: this.sectionTitle,
      product_guids: this.productGuids,
      menu_product_guids: this.menuProductGuids,
    };
  }

  static populateProductGuidsHierarchically(sectionFilters) {
    const sectionsByGuid = new Map();
    sectionFilters.forEach((filter) => {
      sectionsByGuid.set(filter.sectionGuid, filter);
    });
    sectionFilters.forEach((sectionFilter) => {
      const productsSet = new Set();
      sectionFilter.productGuids.forEach(productsSet.add, productsSet);
      SectionFilters.#getChildProducts(sectionFilter, sectionsByGuid, productsSet);
      sectionFilter.allProductGuids = Array.from(productsSet);
    });
  }

  static #getChildProducts(sectionFilter, sectionsByGuid, products) {
    sectionFilter.childrenGuids.forEach((childGuid) => {
      const childFilter = sectionsByGuid.get(childGuid) || [];
      SectionFilters.#getChildProducts(childFilter, sectionsByGuid, products);
      childFilter.productGuids.forEach(products.add, products);
    });
  }
}
